// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__X27Ge","footer":"ModalFilter_footer__1mrUC"};